import React from "react";
import Chart from "react-apexcharts";

export default function Institution({ data }) {
  return (
    <Chart
      options={data.options}
      series={data.series}
      type="bar"
      height={"400px"}
    />
  );
}
